<template>
    <div>

        <section class="feature-section">
            <div class="container">
                <div class="row ">
                    <div class="col-lg-5 text-left">
                        <h2 class="align-left">AWS Glue on Steriods</h2>
                        <p>
                          Skippr is your on-boarding ramp to AWS Glue and Athena. Discover complete nested data schemas, evolve schemas over time with backwards compatibility and automated the sync of data schemas and Glue tables
                        </p>
                    </div>
                    <div class="col-lg-5 col-xs-offset-1">
                        <figure>
                          <img src="images/homepage/glue.png" width="100%">
                        </figure>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
    export default {
        name: 'SchemaDrift',
        props: {
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
